import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callProc } from "../../services/api"; // POST /api/executeprocedure helper (axios instance with auth interceptors)

/* ─────────────────────────────────────────────────────────────────────────────
   fetchMenus
   Calls the EmployeeMenus procedure via /api/executeprocedure
   The backend returns ONLY the menus & pages this employee has VIEW access to,
   already merged from role permissions + employee-level overrides.
───────────────────────────────────────────────────────────────────────────── */
export const fetchMenus = createAsyncThunk(
  "rbac/fetchMenus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await callProc("EmployeeMenus");
      // Response shape: Array<{ _id, name, icon, pages: [{ key, name, route, icon, actions }] }>
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load menus"
      );
    }
  }
);

/* ─────────────────────────────────────────────────────────────────────────────
   Slice
───────────────────────────────────────────────────────────────────────────── */
const rbacSlice = createSlice({
  name: "rbac",
  initialState: {
    menus: [],       // Array of menu objects returned by the API
    loading: false,
    error: null,
  },
  reducers: {
    /** Call this on logout to wipe the cached menu tree */
    clearMenus(state) {
      state.menus = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenus.fulfilled, (state, action) => {
        state.loading = false;
        state.menus = action.payload;
      })
      .addCase(fetchMenus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.menus = [];
      });
  },
});

export const { clearMenus } = rbacSlice.actions;
export default rbacSlice.reducer;